import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { fmtDate } from "@/lib/fmt";
import { money } from "./roasUtil";

function DealValue({ row, onSaved }) {
  const [v, setV] = useState(row.deal_value ?? "");
  const save = async () => {
    if (String(v) === String(row.deal_value ?? "")) return;
    try { await api.put(`/crm/leads/${row.id}`, { deal_value: Number(v || 0) }); toast.success("Deal value saved"); onSaved(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't save"); }
  };
  return (
    <input type="number" min="0" className={`w-28 px-2 py-0.5 rounded border text-xs tabular-nums bg-transparent ${!row.deal_value ? "border-[var(--warn)]" : ""}`}
      value={v} placeholder="add value" onChange={(e) => setV(e.target.value)} onBlur={save} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
      data-testid={`roas-deal-${row.id}`} />
  );
}

function Assign({ row, campaigns, onSaved }) {
  const save = async (cid) => {
    try { await api.put(`/roas/leads/${row.id}/attribution`, { campaign_id: cid || null }); toast.success(cid ? "Linked to campaign" : "Link removed"); onSaved(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't link"); }
  };
  return (
    <select className="px-1.5 py-0.5 rounded border text-xs bg-transparent max-w-[220px]" value={row.attribution === "manual" ? row.campaign_id || "" : ""}
      onChange={(e) => save(e.target.value)} data-testid={`roas-assign-${row.id}`}>
      <option value="">{row.attribution === "utm" ? "Auto (from ad tags)" : "Link to campaign\u2026"}</option>
      {campaigns.filter((c) => c.owner !== "client").map((c) => <option key={c.campaign_id} value={c.campaign_id}>{c.name}</option>)}
    </select>
  );
}

export function RoasClients({ d, campaigns, reload }) {
  const [only, setOnly] = useState("all");
  const rows = d.clients.filter((r) => only === "all" || (only === "missing" ? !r.deal_value : !r.campaign_id));
  const open = (id) => window.open(`/crm?lead=${id}`, "_blank");
  return (
    <section className="panel p-4 overflow-x-auto" data-testid="roas-clients">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <div className="text-sm font-medium flex-1">Converted clients · {d.clients.length}</div>
        {[["all", "All"], ["missing", `No deal value (${d.missing_value})`], ["unattributed", `Not linked to an ad (${d.unattributed_won.length})`]].map(([k, l]) => (
          <button key={k} className={`text-xs ${only === k ? "text-[var(--ai)]" : "text-[var(--text-dim)]"}`} onClick={() => setOnly(k)} data-testid={`roas-clients-filter-${k}`}>{l}</button>
        ))}
      </div>
      <table className="w-full text-xs tabular-nums min-w-[900px]">
        <thead className="text-[var(--text-dim)] text-left">
          <tr>{["Client", "Deal value", "Lead came in", "Won", "Days", "Campaign / ad", "Link", "Owner"].map((h) => <th key={h} className="py-1.5 pr-3 font-normal">{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t border-[var(--border)]" data-testid={`roas-client-${r.id}`}>
              <td className="py-1.5 pr-3"><button className="hover:underline text-left" onClick={() => open(r.id)}>{r.name}</button>
                {r.gmv ? <div className="text-[10px] text-[var(--text-faint)]">event GMV {money(r.gmv)}</div> : null}</td>
              <td className="pr-3"><DealValue row={r} onSaved={reload} /></td>
              <td className="pr-3">{fmtDate(r.created_at)}</td>
              <td className="pr-3">{r.won_at ? fmtDate(r.won_at) : "\u2014"}</td>
              <td className="pr-3">{r.days_to_close ?? "\u2014"}</td>
              <td className="pr-3 max-w-[260px]"><div className="truncate" title={r.campaign}>{r.campaign || <span className="text-[var(--warn)]">not linked</span>}</div>
                {r.ad && <div className="text-[10px] text-[var(--text-faint)] truncate">{r.ad}</div>}</td>
              <td className="pr-3"><Assign row={r} campaigns={campaigns} onSaved={reload} /></td>
              <td className="pr-3 text-[var(--text-dim)]">{(r.owner || "").split("@")[0]}</td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={8} className="py-4 text-[var(--text-dim)]">No won leads that came in during this range.</td></tr>}
        </tbody>
      </table>
    </section>
  );
}
